const Test=[{id:0,text:'未执行'},{id:1,text:'正在执行'},{id:2,text:'执行完成'}];

const CheckboxList=[{key:0,value:'按钮0'},{key:1,value:'按钮1'},{key:2,value:'按钮2'}];

export default  {
  Test,
  CheckboxList
}
